import * as i18next from 'i18next'

export default function i18n(locale, resources) {
  return i18next.init({
    resources,
    lng: locale,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
    lowerCaseLng: true,
    keySeparator: false,
    react: {
      wait: true,
    },
  })
}
